var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import React, { useMemo, useState } from 'react';
import { WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Modal from '@shared/modal/Modal';
import Manager from '@shared/modal/Manager';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import SelectInput from '@shared/input/SelectInput';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCreateWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import { INTERVAL_REG_EXP } from '@util/helpers';
import { NumberFormatType, numberFormatTypesMeta, KpiColumnOperation } from '@util/enums';
import { ModalBody } from '@styled/Modal';
import { useActiveYears } from '@data/hooks/timePoints';
function TimelineSlicerTileEditor(props) {
    return (React.createElement(Modal, { width: 600 },
        React.createElement(TimelineSlicerForm, __assign({}, props))));
}
var TimelineSlicerForm = function (props) {
    var e_1, _a;
    var _b, _c;
    var L = useLanguage().L;
    var createWidget = useCreateWidget();
    var updateWidget = useUpdateWidget();
    var activeYears = useActiveYears();
    var _d = __read(useState(props.widget
        ? props.widget
        : {
            title: '',
            type: WidgetType.SLICER,
            config: JSON.stringify(parseWidgetConfig(null, WidgetType.SLICER)),
            GridId: props.gridId,
        }), 2), widgetState = _d[0], setWidgetState = _d[1];
    var _e = __read(useState({}), 2), invalid = _e[0], setInvalid = _e[1];
    var validate = function (payload, payloadConfig) {
        var invalid = {};
        return invalid;
    };
    var done = function () { return __awaiter(void 0, void 0, void 0, function () {
        var widgetCopy, widgetCopyConfig, _invalid, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    widgetCopy = __assign({}, widgetState);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SLICER);
                    if (widgetCopyConfig.intervalStart === '' || widgetCopyConfig.intervalEnd === '') {
                        widgetCopyConfig.intervalStart = "01/".concat(activeYears[0]);
                        widgetCopyConfig.intervalEnd = "12/".concat(activeYears[activeYears.length - 1]);
                    }
                    _invalid = validate(widgetCopy, widgetCopyConfig);
                    if (!(Object.keys(_invalid).length > 0)) return [3 /*break*/, 1];
                    setInvalid(_invalid);
                    return [3 /*break*/, 6];
                case 1:
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    if (!('id' in widgetCopy)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createWidget.mutateAsync(widgetCopy)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    _a;
                    Manager.closeModal();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleIntervalChange = function (propName, newInterval) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SLICER);
        widgetCopyConfig[propName] = newInterval;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var setNumberFormatType = function (newNumberFormatType) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SLICER);
        widgetCopyConfig.numformat = newNumberFormatType;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var setKpiColOperation = function (newKpiColOperation) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.SLICER);
        widgetCopyConfig.comparisonOperation = newKpiColOperation;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widgetState.config, WidgetType.SLICER); }, [widgetState.config]);
    var interval = {
        start: INTERVAL_REG_EXP.test(widgetConfig.intervalStart) ? widgetConfig.intervalStart : undefined,
        end: INTERVAL_REG_EXP.test(widgetConfig.intervalEnd) ? widgetConfig.intervalEnd : undefined,
    };
    var monthList = [];
    try {
        for (var activeYears_1 = __values(activeYears), activeYears_1_1 = activeYears_1.next(); !activeYears_1_1.done; activeYears_1_1 = activeYears_1.next()) {
            var y = activeYears_1_1.value;
            for (var m = 1; m <= 12; m++) {
                var month = "0".concat(m).slice(-2);
                monthList.push({ label: "".concat(month, "/").concat(y), value: "".concat(month, "/").concat(y) });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (activeYears_1_1 && !activeYears_1_1.done && (_a = activeYears_1.return)) _a.call(activeYears_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var startSplit = interval.start ? interval.start.split('/')[1] + interval.start.split('/')[0] : null;
    var endSplit = interval.end ? interval.end.split('/')[1] + interval.end.split('/')[0] : null;
    var monthListStart = endSplit
        ? monthList.filter(function (item) {
            var vals = item.label.split('/');
            return vals[1] + vals[0] <= endSplit;
        })
        : monthList;
    var monthListEnd = startSplit
        ? monthList.filter(function (item) {
            var vals = item.label.split('/');
            return vals[1] + vals[0] >= startSplit;
        })
        : monthList;
    var start = (_b = interval.start) !== null && _b !== void 0 ? _b : monthList[0].value;
    var end = (_c = interval.end) !== null && _c !== void 0 ? _c : monthList[monthList.length - 1].value;
    var title = props.widget
        ? "".concat(L('Editing Timeline Slicer'), " \"").concat(props.widget.title, "\"")
        : L('Create New Timeline Slicer');
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(SelectInput, { name: "intervalStart", label: L('Interval Start'), value: start, onChange: function (opt) { return handleIntervalChange('intervalStart', String(opt.target.value)); }, options: monthListStart, bottomMargin: true }),
                React.createElement(SelectInput, { name: "intervalEnd", label: L('Interval End'), value: end, onChange: function (opt) { return handleIntervalChange('intervalEnd', String(opt.target.value)); }, options: monthListEnd, bottomMargin: true }),
                React.createElement(SelectInput, { name: "numformat", label: L('Format'), value: widgetConfig.numformat, options: Object.entries(NumberFormatType).map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return ({
                            label: L(numberFormatTypesMeta[value].label),
                            value: value,
                        });
                    }), onChange: function (opt) { return setNumberFormatType(opt.target.value); }, bottomMargin: true }),
                React.createElement(SelectInput, { name: "slicerDiffColOperation", label: L('Operation'), options: Object.entries(KpiColumnOperation).map(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], value = _b[1];
                        return ({
                            value: value,
                            label: L(value),
                        });
                    }), value: widgetConfig.comparisonOperation, onChange: function (opt) { return setKpiColOperation(opt.target.value); }, placeholder: L('Operation'), bottomMargin: true }))),
        React.createElement(ModalFooter, { done: done })));
};
export default TimelineSlicerTileEditor;
